
const getCreateFormText = (brandName: string) => {
    const tooltips = {
        COMMUNITY_COMMUNITYNAME:
            "Choose a meaningful community name that is closely aligned with your content or subject matter.  Community Names can only contain letters, numbers, spaces and the following special characters ( ) - : & . , '",
        COMMUNITY_DESCRIPTION:
            "Provide a detailed description of your community�s content and activities. Use keywords that make your community easier to find and helps users decide whether to follow or join.  Community descriptions can only contain letters, numbers, spaces and the following special characters ( ) - : & . , '",
        COMMUNITY_EXTDESCRIPTION:
            "Provide members with an overview of how to make the most of your community. Call out important channels in your Team or folders to find key documents in your SharePoint site. Include links and format information to help new members know where to start.",
        COMMUNITY_COMMUNITYTYPE:
            'The community type defines how your community is governed and how users may access your community.',
        COMMUNITY_SECONDOWNER:
            'Every community needs at least 2 owners to ensure that administration rights are not lost. Additional owners can be added at any time.',
        COMMUNITY_TAGS:
            'Provide keywords to allow users to search and find your community.'
    };

    const defaults = {
        COMMUNITY_DESCRIPTION: "Some default value just used for testing purposes.",
        COMMUNITY_EXTENDED_DESCRIPTION: `# Welcome to our ${brandName} community!  
A community is an online workspace, with all the tools we need to connect, share and work together.  
Each community has a Team to meet online, collaborate on documents and chat, as well as a SharePoint site to share files and structured information.  
*Community Owner(s) - Edit your community to update this information and provide your members with specific instructions on how to make the most of this community.*`,
        POPUP_NEW_OPEN_COMMUNITY_HEADING: "You are creating an open community. Open communities:",
        POPUP_EXISTING_OPEN_COMMUNITY_HEADING: "Changing a community from Private or Hidden to Open must now be requested:"
    };

    const constants = {
        LINK_BACKTODASHBOARD: 'Back to Dashboard'
    };

    return {tooltips, defaults, constants};
};

export default getCreateFormText;
